import styled from "styled-components";

export const ModalsStyled = styled.div`
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 1);
  z-index: 11;

  .blocoUsuario {
    background: var(--cinza);
    width: 580px;
    border-radius: 10px;
    padding: 10px;
    position: relative;
    border: 3px solid var(--cor-primaria);
    color: var(--cor-contraste);

    h3 {
      text-align: center;
      font-size: 25px;
    }

    .fechaModal {
      position: absolute;
      top: 15px;
      right: 20px;
      font-size: 25px;
      cursor: pointer;
    }

    .inpults {
      position: relative;

      label {
        display: block;
        margin-top: 18px;
        font-size: 14px;
        margin-left: 10px;
      }

      p {
        position: absolute;
        bottom: -25px;
        color: var(--cor-erro);
        right: 10px;
        height: 15px;
      }

      input {
        background: #ffffff;
        box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
        border-radius: 3px;
        width: 100%;
        height: 30px;
        border: none;
        font-size: 18px;
        padding-left: 35px;

        &::placeholder {
          color: var(--cinza);
          font-size: 16px;
        }
      }
      input:focus {
        outline: none;
      }

      span {
        position: absolute;
        bottom: 2px;
        left: 5px;
        font-size: 18px;
      }
    }

    .divSenha {
      display: flex;
      width: 100%;
      justify-content: space-between;
      margin-top: 5px;
      gap: 10px;

      .inputSenha {
        position: relative;
        display: flex;
        align-items: center;
      }

      .inputSenha input {
        flex: 1;
        padding-right: 35px;
      }

      .toggleSenha {
        background: none;
        border: none;
        position: absolute;
        right: 10px;
        cursor: pointer;
      }

      /* div {
        position: relative;
      }

      span {
        position: absolute;
        bottom: 2px;
        left: 10px;
      }

      input {
        width: 100%;
      } */
    }

    .tituloRadiobox {
      margin-top: 30px;
    }

    .checkboxUsuarios {
      display: flex;
      justify-content: center;
      gap: 50px;
      width: 100%;
      margin-top: 10px;
      position: relative;

      div {
        display: flex;
        align-items: center;
        gap: 20px;
        justify-content: center;

        label {
          font-size: 18px;
        }

        input {
          width: 25px;
          height: 25px;
        }

        p {
          position: absolute;
          top: 8px;
          left: 38%;
          height: auto;
          color: var(--cor-erro);
        }
      }
    }
  }

  p {
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 12px;
    margin-top: 35px;
  }

  .botao {
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    button {
      font-size: 18px;
      border-radius: 3px;
      width: 70%;
      height: 40px;
      max-width: 100%;
      cursor: pointer;
      color: var(--cor-primaria);
      font-weight: bold;
      border: 2px solid var(--cor-primaria);
      margin: 25px;
      transition: 0.3s;
    }
    button:hover {
      background-color: var(--cor-primaria);
      color: var(--branco);
      border: 2px solid var(--cor-primaria);
      box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    }
  }

  @media (max-width: 781px) {
    .blocoUsuario {
      .divSenha {
        gap: 10px;
      }
      .tituloRadiobox {
        margin-top: 20px;
      }
    }
  }

  @media (max-width: 648px) {
    .blocoUsuario {
      .checkboxUsuarios {
        div {
          gap: 5px;
        }
      }
    }
  }

  @media (max-width: 625px) {
    .blocoUsuario {
      margin: 30px;
      .inpults {
        input {
          &::placeholder {
            font-size: 14px;
          }
        }
      }
      .checkboxUsuarios {
        margin-top: 8px;
        div {
          display: flex;
          align-items: center;
          gap: 3px;
          justify-content: center;

          label {
            font-size: 15px;
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    .blocoUsuario {
      width: 80%;
      .divSenha {
        margin-top: 8px;
      }
      .checkboxUsuarios {
        div {
          label {
            font-size: 12px;
          }
          p {
            top: 6px;
          }
        }
      }
    }
  }

  @media (max-width: 415px) {
    .blocoUsuario {
      width: 90%;
      .inpults {
        input {
          &::placeholder {
            font-size: 11px;
          }
        }
      }
      .checkboxUsuarios {
        div {
          p {
            top: 10px;
          }
        }
      }
    }
  }
`;

export const ModalsConfirmeStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 11;

  .blocoConfirma {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: var(--cinza);
    border: 3px solid var(--cor-primaria);
    width: 700px;
    max-width: 100%;
    border-radius: 10px;
    margin: 0 60px;
    padding: 25px;
    color: var(--cor-contraste);

    h3 {
      text-align: center;
      font-size: 25px;
    }

    .botao {
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
      gap: 30px;

      button {
        font-size: 18px;
        background: var(--branco);
        border-radius: 3px;
        width: 250px;
        height: 40px;
        max-width: 100%;
        cursor: pointer;
        color: var(--cor-primaria);
        font-weight: bold;
        border: 2px solid var(--cor-primaria);
        margin-top: 50px;
        transition: 0.3s;
      }
      button:hover {
        background-color: var(--cor-primaria);
        color: var(--branco);
        border: 2px solid var(--cor-primaria);

        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
      }
    }
  }
  @media (max-width: 625px) {
    .blocoConfirma {
      .botao {
        flex-wrap: wrap;
        gap: 15px;
      }
    }
  }
`;

// responsividade ok
export const ModalsEstacaoStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 11;

  .blocoEstacao {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: var(--cinza);
    border-radius: 10px;
    padding: 15px;
    border: 3px solid var(--cor-primaria);
    color: var(--cor-contraste);
    gap: 15px;

    .titulo {
      display: flex;
      justify-content: space-between;
      align-items: center;
      h3 {
        font-size: 1.6em;
      }
      .fechaModal {
        font-size: 1.6em;
        cursor: pointer;
      }
    }

    .estacao {
      .cadEstacao {
        padding: 15px;
        font-size: 14px;
        font-weight: 700;
        display: flex;

        .divSeletores {
          gap: 20px;
          display: flex;
          flex-direction: column;

          .seletores {
            display: flex;
            flex-direction: column;
            gap: 3px;

            select {
              font-weight: 500;
              width: 200px;
              height: 30px;
              border: none;
              outline: none;
              padding-left: 10px;
              box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
              border-radius: 3px;
            }

            p {
              color: var(--cor-contraste);
              font-size: 10px;
              position: fixed;
              margin-top: 52px;
            }
          }
        }

        .divInputs {
          gap: 20px;
          display: flex;
          flex-direction: column;
          align-items: start;
          margin: 0 0 0 10px;
          font-size: 14px;
          font-weight: 700;

          .inputs {
            display: flex;
            flex-direction: column;
            gap: 3px;

            p {
              color: var(--cor-contraste);
              font-size: 10px;
              position: fixed;
              margin: 52px;
              margin-left: 170px;
            }
            input {
              font-weight: 500;
              width: 300px;
              height: 30px;
              border: none;
              outline: none;
              padding-left: 10px;
              box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
              border-radius: 3px;
            }
            input::placeholder {
              color: var(--cor-contraste);
              opacity: 35%;
              font-size: 0.8rem;
            }
          }
          .divCheck {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 15px;
            margin-top: 15px;
            margin-left: 8px;
            .check {
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 5px;

              input {
                background-color: red;
                width: 30px;
                height: 30px;
                border-radius: 25px;
              }
            }
          }
        }
      }
    }

    .botaoContinuar {
      .botao {
        display: flex;
        justify-content: center;
        button {
          font-size: 1.4em;
          border-radius: 6px;
          width: 50%;
          padding: 1.5%;
          max-width: 100%;
          cursor: pointer;
          color: var(--cor-primaria);
          font-weight: bold;
          border: 2px solid var(--cor-primaria);
          transition: 0.5s;
        }
        button:hover {
          background-color: var(--cor-primaria);
          color: var(--branco);
          border: 2px solid var(--cor-primaria);
          box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
        }
      }
    }
  }

  @media (max-width: 883px) {
    .blocoEstacao {
      margin: 15px;
      padding: 8px;
      gap: 5px;
      .titulo {
        h3 {
          font-size: 1.8em;
        }
        .fechaModal {
          font-size: 1.8em;
        }
      }
      .estacao {
        .cadEstacao {
          padding: 5px 0;
          font-size: 0.9em;
          display: block;

          .divSeletores {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 20px;
            .seletores {
              select {
                width: 300px;
                height: 35px;
                border-radius: 5px;
              }
              p {
                font-size: 0.7em;
                margin-top: 58px;
                margin-left: 170px;
              }
            }
          }

          .divInputs {
            margin: 10px;
            font-size: 0.9em;
            font-weight: 700;

            .inputs {
              p {
                font-size: 0.7em;
                margin-top: 58px;
                margin-left: 173px;
              }
              input {
                border-radius: 5px;
              }
              input::placeholder {
                font-size: 0.9rem;
              }
            }
            .divCheck {
              margin-top: 10px;
              .check {
                input {
                  border-radius: 15px;
                }
              }
            }
          }
        }
      }

      .botaoContinuar {
        .botao {
          display: flex;
          justify-content: center;
          button {
            font-size: 1.4em;
            border-radius: 6px;
            width: 70%;
            padding: 1.5%;
            max-width: 100%;
            cursor: pointer;
            color: var(--cor-primaria);
            font-weight: bold;
            border: 2px solid var(--cor-primaria);
            transition: 0.3s;
          }
          button:hover {
            background-color: var(--cor-primaria);
            color: var(--branco);
            border: 2px solid var(--cor-primaria);
            box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
          }
        }
      }
    }
  }
`;

export const ModalsPocoStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 11;

  .blocoPoco {
    background: var(--cinza);
    width: 580px;
    height: 430px;
    max-height: 100%;
    overflow: auto;
    border-radius: 10px;
    padding: 10px;
    position: relative;
    border: 3px solid var(--cor-primaria);
    color: var(--cor-contraste);

    form {
      .divPocos {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .divPoco1 {
          h3 {
            text-align: center;
            font-size: 25px;
          }
          .fechaModal {
            position: absolute;
            top: 15px;
            right: 20px;
            font-size: 25px;
            cursor: pointer;
          }
        }
      }
      .tituloP2 {
        text-align: center;
        font-size: 25px;
        margin: 15px 0px;
      }

      .cadPoco {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        font-size: 14px;
        font-weight: 600;
        margin: 30px 0px;

        .divSeletores {
          gap: 20px;
          display: flex;
          flex-direction: column;

          .seletores {
            display: flex;
            flex-direction: column;
            gap: 3px;
            margin-left: 13px;
            p {
              color: var(--cor-erro);
              font-size: 10px;
              position: absolute;
              margin-top: 52px;
              margin-left: 13px;
            }
            input {
              width: 250px;
              height: 30px;
              border: none;
              outline: none;
              padding-left: 10px;
              box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
              border-radius: 3px;
            }
            select {
              width: 250px;
              height: 30px;
              border: none;
              outline: none;
              padding-left: 10px;
              box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
              border-radius: 3px;
            }
          }
        }
      }
      .check {
        gap: 5px;
        display: flex;
        justify-content: center;
        align-items: center;

        input {
          width: 30px;
          height: 30px;
        }
      }

      .botaoContinuar {
        display: flex;
        justify-content: center;
        button {
          font-size: 18px;
          border-radius: 3px;
          width: 70%;
          height: 40px;
          max-width: 100%;
          cursor: pointer;
          color: var(--cor-primaria);
          font-weight: bold;
          border: 2px solid var(--cor-primaria);
          margin: 25px;
          transition: 0.3s;
        }
        button:hover {
          background-color: var(--cor-primaria);
          color: var(--branco);
          border: 2px solid var(--cor-primaria);
          box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
        }
      }
    }
  }

  @media (max-width: 883px) {
    .blocoPoco {
      width: 500px;
      form {
        .cadPoco {
          .divSeletores {
            .seletores {
              input {
                width: 200px;
              }
              select {
                width: 200px;
              }
            }
          }
        }
      }
    }
  }
`;

export const ModalsBombaStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 1);
  z-index: 11;

  .blocoBomba {
    background: var(--cinza);
    width: 580px;
    height: 430px;
    max-height: 100%;
    overflow: auto;
    border-radius: 10px;
    padding: 10px;
    position: relative;
    border: 3px solid var(--cor-primaria);
    color: var(--cor-contraste);

    h3 {
      text-align: center;
      font-size: 25px;
    }
    .fechaModal {
      position: absolute;
      top: 15px;
      right: 20px;
      font-size: 25px;
      cursor: pointer;
    }
    .tituloBombas {
      margin: 20px;
      text-align: center;
      font-size: 25px;
    }
    .cadPoco {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 600;
      margin: 30px 0px;

      .divSeletores {
        gap: 10px;
        display: flex;
        flex-direction: column;
        .seletores {
          display: flex;
          flex-direction: column;
          gap: 3px;
          input {
            margin-right: 10px;
            width: 200px;
            height: 30px;
            border: none;
            outline: none;
            padding-left: 10px;
            box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
            border-radius: 3px;
          }
          select {
            width: 200px;
            height: 30px;
            border: none;
            outline: none;
            padding-left: 10px;
            box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
            border-radius: 3px;
          }
          p {
            color: var(--cor-erro);
            font-size: 10px;
            position: absolute;
            margin-top: 52px;
            margin-left: 5px;
          }
        }
        .imgBomba {
          background-color: var(--branco);
          display: flex;
          justify-content: center;
          box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
          border-radius: 3px;
          border: px solid var(--cor-secundaria);

          img {
            width: 246px;
            height: 170px;
          }
        }
      }
    }

    .botaoContinuar {
      display: flex;
      justify-content: center;

      button {
        font-size: 18px;
        border-radius: 3px;
        width: 70%;
        height: 40px;
        max-width: 100%;
        cursor: pointer;
        color: var(--cor-primaria);
        font-weight: bold;
        border: 2px solid var(--cor-primaria);
        margin: 25px;
        transition: 0.3s;
      }

      button:hover {
        background-color: var(--cor-primaria);
        color: var(--branco);
        border: 2px solid var(--cor-primaria);
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
      }
    }
  }
`;

export const ModalUpdateEstacaoStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 11;
  padding: 0 20px;

  .Editar {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: var(--cinza);
    width: 900px;
    height: 650px;
    max-width: 100%;
    border-radius: 10px;
    padding: 2vh;
    border: 3px solid var(--cor-primaria);
    color: var(--cor-contraste);
    /* gap: 15px; */

    .titulo {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 15px 0;
      h3 {
        font-size: 1.4em;
      }
      .fechaModal {
        font-size: 1.6em;
        cursor: pointer;
      }
    }

    .botoesEdit {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      margin: 0 0 15px 0;
    }

    .divUpdate {
      overflow: auto;
    }

    .botao {
      font-size: 1em;
      background: var(--branco);
      border-radius: 3px;
      width: 30%;
      padding: 0.6em 0;
      cursor: pointer;
      color: var(--cor-primaria);
      font-weight: bold;
      border: 2px solid var(--cor-primaria);
      transition: 0.3s;
    }

    @media (max-width: 440px) {
      .botao {
        font-size: 0.9em;
      }
    }

    .btPoco {
      background: var(--degrade);
      color: var(--branco);
      border: 2px solid var(--cor-primaria);
      box-shadow: 2px 2px 10px var(--shadow);
      cursor: initial;
    }

    .botao:hover {
      background: var(--degrade);
      color: var(--branco);
      border: 2px solid var(--cor-primaria);
      box-shadow: 2px 2px 10px var(--shadow);
    }
  }
`;

export const ModalRelatorioBombaStyled = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  z-index: 5;
  align-items: center;
  justify-content: center;

  .Conteiner {
    display: flex;
    flex-direction: column;
    margin: 20%;
    width: 100%;
    height: 60%;
    background: var(--branco);
    border: 3px solid var(--cor-primaria);
    border-radius: 15px;
    padding: 20px;
    position: relative;

    h3 {
      text-align: center;
      color: var(--cor-primaria);
    }
    .noRelatorio {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 25px;
      height: 100%;
      width: 100%;
    }
    ul {
      display: flex;
      justify-content: center;
      margin-top: 15px;
      flex-direction: column;
      height: 91%;
      border-radius: 10px;

      li {
        display: flex;

        width: 100%;
        margin: 0px 10px 10px 0px;
        padding: 10px 10px;
        justify-content: space-between;
        background-color: rgba(224, 224, 224, 0.8);
        border-radius: 5px;
        p {
          font-size: 18px;
          font-weight: 500;
          /* border-bottom: 2px solid rgba(0, 0, 0, 0.8); */
          text-align: start;
          justify-content: start;
          align-items: start;
        }
        .resultsModal {
          /* border: 2px solid rgba(0, 0, 0, 0.8); */
          padding: 4px;
          border-radius: 10px;
          min-width: 50px;
          display: flex;
          justify-content: center;
        }
      }
    }
    .selectRelatorio {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 5px;
      margin: 15px 0px;
      label {
        font-weight: 600;
        font-size: 18px;
      }
      select {
        padding: 5px;
        border: 3px solid var(--cor-primaria);
        border-radius: 5px;
        min-width: 110px;
        text-align: center;
      }
    }
    .buttonsRelatorio {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: end;
      gap: 20px;

      height: 50px;
      button {
        padding: 10px 20px;
        background: var(--branco);
        transition: 0.5s;
        font-weight: bold;
        border: 3px solid var(--cor-primaria);
        border-radius: 5px;
        color: var(--cor-primaria);
        cursor: pointer;
      }
      button:hover {
        background: var(--cor-primaria);
        color: var(--branco);
        border: 3px solid var(--cor-primaria);
        box-shadow: 2px 2px 10px var(--shadow);
        transition: 0.5s;
      }
    }
  }
  .closeModal {
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    right: -5px;
    top: -5px;
    font-size: 30px;
    cursor: pointer;
    background-color: white;
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }

  @media (max-width: 883px) {
    .Conteiner {
      margin: 5%;
      h3 {
      }
      .noRelatorio {
      }
      ul {
        height: 85%;
        li {
          p {
          }
          .resultsModal {
          }
        }
      }
    }
  }
`;

export const ModalRelatoriosStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100dvh;
  background-color: rgba(0, 0, 0, 0.7);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 1);
  z-index: 11;
  .conteiner {
    display: flex;
    flex-direction: column;
    gap: 25px;
    padding: 10px;
    position: relative;
    width: 80%;
    height: 85dvh;
    background: var(--branco);
    border: 3px solid var(--cor-primaria);
    border-radius: 15px;
    @media (max-width: 660px) {
      width: 95%;
      height: 93dvh;
    }
    .closeModal {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: -5px;
      top: -5px;
      font-size: 30px;
      cursor: pointer;
      background-color: white;
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
    .barSelect::-webkit-scrollbar {
      display: none; /* Chrome, Safari e Edge */
    }
    .barSelect {
      display: flex;
      width: 100%;
      margin: 5px;

      .ulconteiner::-webkit-scrollbar {
        display: none; /* Chrome, Safari e Edge */
      }
      .ulconteiner {
        width: 100%;
        overflow-x: scroll;
        gap: 10px;
        list-style: none;
        display: flex;
        justify-content: space-around;
        padding-top: 20px;
        -ms-overflow-style: none;
        li {
          display: flex;
          justify-content: center;
          color: var(--cor-primaria);
          width: 100%;
          font-size: 18px;
          font-weight: 600;
          padding: 8px 15px;
          border-radius: 5px;
          border: 3px solid var(--cor-primaria);
          cursor: pointer;
        }
        li:hover {
          background-color: var(--cor-primaria);
          color: var(--branco);
          transition: 0.5s;
        }
        .desativar {
          opacity: 0.3;
          cursor: not-allowed;
        }
        .select {
          background-color: var(--cor-primaria);
          color: var(--branco);
        }
      }
    }
    .PocoRelatorio {
      display: flex;
      gap: 25px;
      width: 100%;
      justify-content: center;
      align-items: center;

      height: 100%;
      @media (max-width: 800px) {
        flex-direction: column;
        overflow: auto;
      }
      .DataPoco {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 25px;
        border-radius: 10px;
        position: relative;
        @media (max-width: 1160px) {
          width: 60%;
        }
        @media (max-width: 800px) {
          width: 90%;
          gap: 10px;
        }
        .botaoFechaAgenda {
          position: absolute;
          top: -8px;
          right: -10px;
          font-size: 18px;
          background: var(--branco);
          border-radius: 3px;
          width: 30px;
          height: 30px;
          max-width: 100%;
          cursor: pointer;
          color: var(--cor-primaria);
          font-weight: bold;
          border: 2px solid var(--cor-primaria);
          border-radius: 50%;
          transition: 0.3s;
        }
        .botaoFechaAgenda:hover {
          background-color: var(--cor-primaria);
          color: var(--branco);
          border: 2px solid var(--cor-primaria);

          box-shadow: 2px 2px 10px var(--shadow);
        }
        .selectRelatorio {
          label {
            font-weight: 600;
            font-size: 18px;
          }
          select {
            border: 2pxx solid var(--cor-primaria);
            padding: 5px;
            border-radius: 5px;
          }
        }
        .buttonsRelatorio {
          display: flex;
          width: 100%;
          justify-content: center;
          align-items: end;
          gap: 20px;

          height: 50px;
          button {
            padding: 10px 20px;
            background: var(--branco);
            transition: 0.5s;
            font-weight: bold;
            border: 3px solid var(--cor-primaria);
            border-radius: 5px;
            color: var(--cor-primaria);
            cursor: pointer;
          }
          button:hover {
            background: var(--cor-primaria);
            color: var(--branco);
            border: 3px solid var(--cor-primaria);
            box-shadow: 2px 2px 10px var(--shadow);
            transition: 0.5s;
          }
        }
      }
      .GraficoPoco {
        width: 60%;
        max-height: 480px;
        height: 100%;
        @media (max-width: 800px) {
          width: 100%;
          height: 800px;
          max-height: 4180px;
        }
      }
    }
    .AcionamentosRelatorio {
      overflow: auto;
      height: 100%;
      .selecBombas {
        display: flex;
        justify-content: center;
        width: 100%;
        overflow-x: scroll;
        nav {
          width: fit-content;
        }
        ul {
          display: flex;
          list-style: none;
          width: fit-content;
          height: fit-content;
          justify-content: center;
          gap: 15px;
          animation: slide-bottom 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
          li {
            display: flex;
            justify-content: center;
            color: var(--cor-primaria);
            width: 250px;
            max-width: 100%;
            font-size: 16px;
            padding: 8px 15px;
            border-radius: 5px;
            border: 3px solid var(--cor-primaria);
            cursor: pointer;
            @media (max-width: 660px) {
              width: 150px;
              font-size: 14px;
            }
          }
          li:hover {
            background-color: var(--cor-primaria);
            color: var(--branco);
            transition: 0.5s;
          }
          .selectButton {
            background-color: var(--cor-primaria);
            color: var(--branco);
          }
        }
      }
      .selecBombas::-webkit-scrollbar {
        display: none; /* Chrome, Safari e Edge */
      }
      .ConteinerAcinamesntos {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        min-height: 100%;
        border-radius: 15px;
        padding: 20px;
        position: relative;
        h3 {
          text-align: center;
          color: var(--cor-primaria);
        }

        .infoRelatorio {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          gap: 25px;
          width: 100%;
          height: 100%;
          @media (max-width: 1000px) {
            flex-direction: column;
            align-items: center;
            /* overflow: scroll; */
            /* height: 80%; */
          }

          .calendario {
            display: flex;
            justify-content: center;
            height: 100%;
            padding-top: 25px;
            align-items: first baseline;
            .agenda {
            }
          }
          .noRelatorio {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 25px;
            height: 100%;
            width: 100%;
          }
          ul {
            display: flex;
            justify-content: center;
            margin-top: 15px;
            flex-direction: column;
            height: 91%;
            border-radius: 10px;

            width: 100%;

            li {
              display: flex;
              width: 100%;
              margin: 0px 10px 10px 0px;
              padding: 10px 10px;
              justify-content: space-between;
              background-color: rgba(224, 224, 224, 0.8);
              border-radius: 5px;
              .tooltip {
                position: relative;
                cursor: pointer;
                margin-left: 8px;
                font-size: 20px;
                width: 20px;
                height: 20px;
                top: 5px;
              }

              .tooltip .tooltip-text {
                visibility: hidden;
                width: max-content;
                max-width: 200px;
                background-color: #333;
                color: #fff;
                text-align: left;
                border-radius: 6px;
                padding: 5px 8px;
                position: absolute;
                z-index: 1;
                bottom: 125%; /* Acima do texto */
                left: 100%;
                transform: translateX(-40%);
                opacity: 0;
                transition: opacity 0.3s;
                font-size: 12px;
                white-space: normal;
              }

              .tooltip:hover .tooltip-text {
                visibility: visible;
                opacity: 1;
              }
              p {
                font-size: 18px;
                font-weight: 500;
                /* border-bottom: 2px solid rgba(0, 0, 0, 0.8); */
                text-align: start;
                justify-content: start;
                align-items: start;
              }
              .resultsModal {
                /* border: 2px solid rgba(0, 0, 0, 0.8); */
                padding: 4px;
                border-radius: 10px;
                min-width: 50px;
                display: flex;
                justify-content: center;
              }
            }
          }
          .selectRelatorio {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 5px;
            margin: 15px 0px;
            label {
              font-weight: 600;
              font-size: 18px;
            }
            select {
              padding: 5px;
              border: 3px solid var(--cor-primaria);
              border-radius: 5px;
              min-width: 110px;
              text-align: center;
            }
          }
          .buttonsRelatorio {
            display: flex;
            width: 100%;
            justify-content: center;
            align-items: end;
            gap: 20px;

            height: 50px;
            button {
              padding: 10px 20px;
              background: var(--branco);
              transition: 0.5s;
              font-weight: bold;
              border: 3px solid var(--cor-primaria);
              border-radius: 5px;
              color: var(--cor-primaria);
              cursor: pointer;
            }
            button:hover {
              background: var(--cor-primaria);
              color: var(--branco);
              border: 3px solid var(--cor-primaria);
              box-shadow: 2px 2px 10px var(--shadow);
              transition: 0.5s;
            }
          }
        }
      }
    }
  }
`;
